import React, { FC } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

import { CreateRole } from './components/CreateRole';
import { RolesTable } from './components/RolesTable';
import { rolesSaga } from './saga';
import { reducer, sliceKey } from './slice';

interface IRoles {}

export const Roles: FC<IRoles> = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: rolesSaga });

  return (
    <Routes>
      {/* Relative paths: Roles is mounted at "/setup/roles/*", so the old
          absolute paths never matched and both pages rendered nothing. */}
      <Route path="add" element={<CreateRole />} />
      <Route index element={<RolesTable />} />
    </Routes>
  );
};
